<template>
    <div class="col-md-12 px-0 py-0">
        <div>
            <div class="row">
                <div class="col-md-7">
                    <button
                        type="button"
                        @click="showBody(0)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 0 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Lista
                    </button>
                    <button
                        type="button"
                        @click="showCreate(1)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 1 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Agregar
                    </button>
                    <button
                        type="button"
                        @click="showBody(3)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 3 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Ordenar
                    </button>
                </div>
                <div class="col-md-5 text-right align-top text-success">
                    <span style="font-size: 20px">Criterios de Evaluación</span>
                </div>
            </div>

            <question-criteria-list-component
                v-if="page == 0"
                v-bind:model_id="model_id"
                @change="callChangeList"
            ></question-criteria-list-component>
            <question-criteria-form-component
                v-if="page == 1"
                v-bind:parent_id="model_id"
                v-bind:model_id="contest_question_criteria_id"
                @change="callChangeCreate"
                :key="componentKey"
            ></question-criteria-form-component>
            <question-criteria-form-component
                v-if="page == 2"
                v-bind:parent_id="model_id"
                v-bind:model_id="contest_question_criteria_id"
            ></question-criteria-form-component>
            <question-criteria-order-component
                v-if="page == 3"
                v-bind:model_id="model_id"
            ></question-criteria-order-component>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            page: 0,
            contest_question_criteria_id: 0,
            componentKey: 0,
            pass: null,
        };
    },
    methods: {
        showCreate() {
            this.contest_question_criteria_id = 0;
            this.page = 1;
            this.componentKey += 1;
        },
        showBody(vallue) {
            this.page = vallue;
            this.contest_question_criteria_id = 0;
        },
        callChangeList(id) {
            this.contest_question_criteria_id = id;
            this.page = 2;
        },
        callChangeCreate() {
            this.page = 0;
        },
    },
    mounted() {},
};
</script>
